import { render, staticRenderFns } from "./CustomerTrainingItemAssignment.vue?vue&type=template&id=a2b4619a&"
import script from "./CustomerTrainingItemAssignment.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingItemAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports